import { api } from "../api";

export default async function addAsset(encodedId: string): Promise<number> {
  try {
    const response = await api.post("/user/wallet/assets", {
      encoded_id: encodedId,
    });

    return response.status;
  } catch (err: any) {
    console.log(err);

    return err.response.status;
  }
}
